import React from 'react'
import styled from 'styled-components'

import { ILabel, ILabelStyle } from './index'

const SLabel = styled.label<ILabelStyle>`
  width: 100%;
  ${(props) => props.position === 'left' && `
    display: flex;
    align-items: center;
  `}
`

const STitle = styled.div<ILabelStyle>`
  font-size: ${(props) => props.theme.typography.inputFontSize};

  ${(props) => props.position === 'left' ? `
    width: 150px;
    overflow-x: hidden;
    flex-shrink: 0;
    flex-grow: 0;
  ` : 'margin-bottom: 5px'}
`

const SInput = styled.div<ILabelStyle>`
  
  ${(props) => props.position === 'left' ? 'width: calc(100% - 150px);' : 'width: 100%;'}
`

const Label: React.FC<ILabel> = (props) => {
  const {children, className, label, position = 'left', ...rest} = props

  return (
    <SLabel position={position} className={className} {...rest}>
      <STitle position={position}>{label}</STitle>
      <SInput position={position}>{children}</SInput>
    </SLabel>
  )
}

export default Label